import { useState } from "react";
import { url } from "../utils/config";
import postData from "../custom_functions/postData";
import { toast } from "react-toastify";
import { btnCancel, btnOne, modalContainer, } from "../utils/style";
import {
    calculateBundleCost,
    calculateMaterialCost,
    calculateTotalDiscount,
    returnDiscount,
    formatDate,
} from "../helperFunctions/estimateCalculation";
import formatNumberToUs from "../custom_functions/formatNumberToUs";
import { formatTime } from "../helperFunctions/formatTime.js";
import Loader from "../reusable_components/Loader.jsx";

function FleetInvoicePreview({ setShowPreview, selectedRows, setSelectedRows, setReloadTable, reloadTable, }) {
    const [description, setDescription] = useState("")
    const [po, setPo] = useState("")
    const [loader, setLoader] = useState(false);

    const generateInvoice = () => {
        setLoader(true)
        if (!selectedRows.length) {
            setLoader(false)
            return toast.error("No work order selected.", { autoClose: 3000 });
        }
        if (po !== "" && !/^[a-zA-Z0-9_-]{1,20}$/.test(po)) {
            setLoader(false);
            return toast.error("Invalid PO Number", { autoClose: 3000 });
        }

        if (description === "") {
            setLoader(false)
            return toast.error("Invoice description is required", { autoClose: 3000 });
        }

        const selectedIds = selectedRows.map(row => row.id);

        postData(`${url}/generate_fleet_invoice`, { estimateIds: selectedIds, invoiceDescription: description, poNumber: po }, (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 })
            setLoader(false)
        }, (data) => {
            toast.success(data.message, { autoClose: 3000 })
            setSelectedRows([]);
            setReloadTable(!reloadTable);
            setShowPreview(false)
            setLoader(false)
        })
    }


    const totalMaterialCost = selectedRows.reduce((sum, est) => {
        return sum + est.materialCost;
    }, 0);

    console.log("totalMaterialCost===>", totalMaterialCost)

    const totalBundleCost = selectedRows.reduce((sum, est) => {
        return sum + calculateBundleCost(est.bundleList);
    }, 0);

    console.log("totalBundleCost===>", totalBundleCost)


    const totalTechnicianCost = selectedRows.reduce((sum, estimate) => {
        return sum + estimate.technicianCost;
    }, 0);

    console.log("totalTechnicianCost===>", totalTechnicianCost)

    const totalDiscount = selectedRows.reduce((sum, estimate) => {
        const discount = calculateTotalDiscount(
            estimate.materialList,
            estimate.serviceList,
            estimate.bundleList
        );
        return sum + discount;
    }, 0);


    const totalTax = selectedRows.reduce((sum, estimate) => {
        return sum + estimate.tax;
    }, 0);
    console.log("totalTax===>", totalTax)

    const finalCost = selectedRows.reduce((sum, estimate) => {
        return sum + estimate.totalCostFinal;
    }, 0);

    console.log("finalCost===>", finalCost)


    function EstimateDescription({ estimate, index }) {

        const bundleCost = calculateBundleCost(estimate.bundleList);
        const materialCost = calculateMaterialCost(estimate.materialList);

        return (
            <table className='w-full mb-4 text-sm text-center'>
                <thead>
                    <tr className="bg-customTwo text-black font-semibold text-xs">
                        <th className="px-4 py-1 border border-gray-300">
                            Description of work - Estimate #{index + 1}
                        </th>
                        <th className="px-4 py-1 border border-gray-300">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {/* Bundles */}
                    <tr>
                        <td className="px-4 py-1 border border-gray-200">
                            <p className="text-left text-xs font-semibold">Service Bundle </p>
                            <table className='w-full mb-4 text-[12px] text-center'>
                                <thead>
                                    <tr className="font-semibold">
                                        <th>No.</th>
                                        <th>Name</th>
                                        <th>Subtotal</th>
                                        <th>Discount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {estimate.bundleList?.data?.map((item, ind) => (
                                        <tr key={ind}>
                                            <td>{ind + 1}</td>
                                            <td>{item.name}</td>
                                            <td>{`$${formatNumberToUs(item.cost)}`}</td>
                                            <td>{`$${formatNumberToUs(returnDiscount(item))}`}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </td>
                        <td className="px-4 py-1 border border-gray-200 text-xs">
                            {`$${formatNumberToUs(bundleCost)}`}
                        </td>
                    </tr>

                    {/* Materials */}
                    <tr>
                        <td className="px-4 py-1 border border-gray-200">
                            <p className="text-left text-xs font-semibold">Parts </p>
                            <table className='w-full mb-4 text-[12px] text-center'>
                                <thead>
                                    <tr className="font-semibold">
                                        <th>No.</th>
                                        <th>Name</th>
                                        <th>Subtotal</th>
                                        <th>Discount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {estimate.materialList?.data?.map((item, ind) => (
                                        <tr key={ind}>
                                            <td>{ind + 1}</td>
                                            <td>{item.name}</td>
                                            <td>{`$${formatNumberToUs(item.cost)}`}</td>
                                            <td>{`$${formatNumberToUs(returnDiscount(item))}`}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </td>
                        <td className="px-4 py-1 border border-gray-200 text-xs">
                            {`$${formatNumberToUs(materialCost)}`}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }


    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-lg p-4 w-2/3 overflow-y-scroll max-h-full">
                <div className={`text-sm text-center font-semibold text-gray-800 mb-6`}> Invoice Preview</div>
                <div className="flex flex-row justify-end mb-2">
                    <input
                        className="rounded-xl px-4 py-2 outline-none border-none bg-customTwo my-1 text-sm placeholder:font-light"
                        placeholder="PO Number"
                        onChange={(e) => setPo(e.target.value)}
                    />
                </div>

                {selectedRows.map((estimate, index) =>
                    <div key={index}>
                        <table className='w-full mb-4 text-xs text-center'>
                            <thead>
                                <tr className="bg-customTwo text-black font-semibold text-xs">
                                    <th className="px-4 py-1 border border-gray-300">VIN</th>
                                    <th className="px-4 py-1 border border-gray-300">Make</th>
                                    <th className="px-4 py-1 border border-gray-300">Model</th>
                                    <th className="px-4 py-1 border border-gray-300">Year</th>
                                    <th className="px-4 py-1 border border-gray-300">Estimated Completion Date</th>
                                    <th className="px-4 py-1 border border-gray-300">Estimated Completion Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr key={index}>
                                    <td className="px-4 py-1 border border-gray-200">{estimate.fleet_customer_car.vin}</td>
                                    <td className="px-4 py-1 border border-gray-200">{estimate.fleet_customer_car.make}</td>
                                    <td className="px-4 py-1 border border-gray-200">{estimate.fleet_customer_car.model}</td>
                                    <td className="px-4 py-1 border border-gray-200">{estimate.fleet_customer_car.year}</td>
                                    <td className="px-4 py-1 border border-gray-200">{formatDate(estimate.estimatedDate)}</td>
                                    <td className="px-4 py-1 border border-gray-200">{formatTime(estimate.estimatedTime)}</td>
                                </tr>
                            </tbody>
                        </table>
                        {<EstimateDescription estimate={estimate} index={index} />}
                    </div>
                )}
                <div className="flex flex-row justify-between px-4 text-xs">
                    <span className="font-semibold"> Total Labor Cost:</span> <span>{`$${formatNumberToUs(totalTechnicianCost)}`}</span>
                </div>
                <div className="flex flex-row justify-between px-4 text-xs">
                    <span className="font-semibold"> Total Service Cost:</span> <span>{`$${formatNumberToUs(totalBundleCost)}`}</span>
                </div>
                <div className="flex flex-row justify-between px-4 text-xs">
                    <span className="font-semibold"> Parts Cost:</span> <span>{`$${formatNumberToUs(totalMaterialCost)}`}</span>
                </div>
                <div className="flex flex-row justify-between px-4 text-xs">
                    <span className="font-semibold"> Discount:</span> <span>{`$${formatNumberToUs(totalDiscount)}`}</span>
                </div>
                <div className="flex flex-row justify-between px-4 text-xs">
                    <span className="font-semibold"> Taxes [{selectedRows[0].fleet_booking.taxRatePercent}%]:</span> <span>{`$${formatNumberToUs(totalTax)}`}</span>
                </div>
                <div className="flex flex-row justify-between px-4 text-xs">
                    <span className="font-semibold"> Total:</span> <span>{`$${formatNumberToUs(finalCost)}`}</span>
                </div>
                <div className="px-12 mt-4">
                    <textarea
                        className="rounded-xl px-4 py-2 outline-none border-none bg-customTwo w-full my-1 text-sm placeholder:font-light"
                        placeholder="Invoice Description"
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>

                <div className="flex justify-between px-16 gap-8 mt-6">
                    <button onClick={() => setShowPreview(false)} className={btnCancel}>Cancel</button>
                    <button className={btnOne} onClick={() => generateInvoice()} disabled={loader}>
                        <span className="flex gap-2 justify-center">Send Invoice{loader && <Loader />}</span>
                    </button>
                </div>
            </div>

        </div >
    )

}

export default FleetInvoicePreview;